export { Selection } from '@fluentui/utilities';
//# sourceMappingURL=Selection.js.map